/**
 * Marca do Mania 3D. O símbolo é um cubo isométrico com UMA face em vermelho —
 * a essência do site: o móvel 3D com a peça destacada.
 */
export function LogoMark({ size = 30 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" aria-hidden="true">
      {/* face de cima */}
      <path d="M24 4 L41 14 L24 24 L7 14 Z" fill="#d6deea" />
      {/* face esquerda */}
      <path d="M7 14 L24 24 L24 44 L7 34 Z" fill="#8a939f" />
      {/* face direita = peça destacada */}
      <path d="M41 14 L41 34 L24 44 L24 24 Z" fill="#e23b3b" />
      {/* arestas (contorno sutil) */}
      <path
        d="M24 4 L41 14 L41 34 L24 44 L7 34 L7 14 Z M7 14 L24 24 L41 14 M24 24 L24 44"
        stroke="#0e1116"
        strokeWidth="1.3"
        strokeLinejoin="round"
        strokeLinecap="round"
        opacity="0.22"
      />
    </svg>
  );
}

export function Logo({ size = 30 }: { size?: number }) {
  return (
    <span className="logo">
      <LogoMark size={size} />
      <span className="logo-text">
        Mania <span className="logo-3d">3D</span>
      </span>
    </span>
  );
}
